'use strict';

function init() { 
  setPlaceholderLabelHandlers();
  styleRadios();
}

/**
 * A "Placeholder Label" is a label that appears inside the input as if it were a placeholder.  The surrounding gfield 
 * container is given the gfield--placeholderLabel class when the label is shown this way.
 * 
 * If the field is focused or contains a value, the label will be shown normally, not as a placeholder.
 */
function setPlaceholderLabelHandlers() {
  // Add empty option to each select
  document.querySelectorAll('.gfield--type-select select').forEach(dropdown => {
    const emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.disabled = true;
    
    dropdown.add(emptyOption, 0);
    dropdown.selectedIndex = 0;
  });
  
  // Have fields listen for changes to enable/disable placeholder labels
  const fieldsWithPlaceholderLabels = document.querySelectorAll('.gfield--type-text, .gfield--type-email, .gfield--type-phone, .gfield--type-textarea, .gfield--type-select'
    + ', .ginput_container_address .gform-grid-col');
  
  fieldsWithPlaceholderLabels.forEach(field => {
    const input = field.querySelector('input,textarea,select');

    input.addEventListener('change', handlePlaceholderLabelUpdate);
    input.addEventListener('focus', handlePlaceholderLabelUpdate);
    input.addEventListener('blur', handlePlaceholderLabelUpdate);
    
    // Initialize fields based on values.
    handlePlaceholderLabelUpdate(input);

    // After initializing, enable transitions.  This avoids the labels from
    // transitioning on page load
    field.classList.add('gfield--labelTransition');
  });
}

function handlePlaceholderLabelUpdate(e) {
  const input = (e instanceof Event) ? e.target : e;
  const field = input.closest('.gfield,.gform-grid-col');
  
  if (!field) { return; }

  const label = field.querySelector('.gfield_label');
  const hasValue = !!input.value;
  const hasFocus = (document.activeElement === input);
  const isPlaceholder = (!hasValue && !hasFocus);

  field.classList.toggle('gfield--placeholderLabel', isPlaceholder);
}

function styleRadios() {
  // Add a listener to each input
  document.querySelectorAll('.gfield_radio .gfield-choice-input').forEach(r => {
    r.addEventListener('change', function() {
      styleRadioGroup(this.closest('.gfield_radio'));
    });
  });

  document.querySelectorAll('.gfield_radio').forEach(grp => styleRadioGroup(grp));
}

function styleRadioGroup(radioGroupEl) {
  radioGroupEl.querySelectorAll('.gfield-choice-input').forEach(r => {
    // And toggle gfield-radio--checked to their wrapper based on their state
    r.closest('.gchoice').classList.toggle('gfield-radio--checked', r.matches(':checked'));
  });
}

export default { init };